import { TransferStates } from '../constant/transfer-states';
import { TRANSFER_TYPES } from '../constant/transfer-types';
import TransferItem from '../models/transfer-item';
import { CURRENCIES } from '@wetransfer/transfer/store/types';

export interface TransfersShared {
  deleted_at?: string;
  display_name: string;
  id: string;
  state: TransferStates;
  size: number;
  expiry_in_seconds: number;
  expires_at: string;
  password_protected: boolean;
  transfer_type: 1 | 4;
  security_hash: string;
  shortened_url?: string;
  uploaded_at?: string;
}

interface SharedTransferItem {
  id: string;
  item_type: string;
  name: string;
  retries: number;
  size: number;
  apiType?: string;
}

type DownloadTransferItem = {
  content_identifier: string;
  previewable: boolean;
} & SharedTransferItem;

export interface ItemsTree {
  uiType: string;
  name: string;
  map: Record<string, NormalizedItem>;
  items: NormalizedItem[];
}

export type OwnedTransferItem = {
  content_identifier: string;
  previewable: boolean;
  item_type: string;
} & SharedTransferItem;

export type DownloadTransferResponseRaw = {
  description: string;
  recipient_id: string;
  items: DownloadTransferItem[];
  creator?: {
    auth0_user_id: string;
    email: string;
  };
} & TransfersShared;

export type OwnedTransferResponseRaw = {
  recipient_id: string;
  account_id: number;
  message: string;
  displayName: string;
  number_of_downloads: number;
  files: OwnedTransferItem[];
  creator?: {
    auth0_user_id: string;
    email: string;
  };
} & TransfersShared;

export interface NormalizedItem {
  id: string | boolean;
  content_identifier: string;
  name: string;
  size: number;
  downloadable: boolean;
  apiType: string;
  file: TransferItem;
  uiType?: string;
  previewable?: boolean;
  items?: NormalizedItem[];
}

export enum SellerAccountStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
}

export interface NormalizedTransfer {
  id: string | boolean;
  title: string;
  expiry: string;
  files: TransferItem[];
  items: NormalizedItem[];
  itemsTree: ItemsTree;
  language: string;
  message: string;
  displayName?: string;
  parent_id: boolean | string;
  password?: string;
  recipients: Recipient[];
  sender: string;
  shortURL?: string;
  state: TransferStates;
  type: Exclude<TRANSFER_TYPES, TRANSFER_TYPES.PROJECT>;
  userType: string;
  uploadStartedAt?: number;
  accountId: number;
  size: number;
  description: string;
  channel?: string;
  domainUserId?: string;
  expiryInSeconds?: number;
  expiresAt?: string;
  from?: string;
  paid: boolean;
  price?: {
    amount: number;
    currency: CURRENCIES;
  };
  seller?: {
    account?: {
      status: SellerAccountStatus;
    };
    avatar?: string;
    name?: string;
    first_name?: string;
    last_name?: string;
  };
  creator?: {
    auth0UserId: string;
    email: string;
  };
}

export interface UploadConfiguration {
  type: Exclude<TRANSFER_TYPES, TRANSFER_TYPES.PROJECT>;
  expiryDate: string;
  message?: string;
  recipients?: Recipient[];
  password?: string;
  parentId?: string | boolean;
}

export interface Recipient {
  email?: string;
  id?: string;
  transfer_downloaded?: boolean;
}
